import { Injectable } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable, Subject, throwError } from "rxjs";
import { debounceTime, map } from "rxjs/operators";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationService } from "@app/_services";

import { User, Users } from "@app/_models";
import { MobilPay } from "@app/_models";
import { ApiBackendService } from "@app/_services/api-backend.service";

import { NzTableQueryParams } from "ng-zorro-antd/table";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "app-users",
  templateUrl: "users.component.html",
  styleUrls: ["users.component.css"],
})
@Injectable({ providedIn: "root" })
export class UsersComponent implements OnInit {
  private searchSubject: Subject<void> = new Subject();
  apiUrl = null;
  loading = true;
  loadingModal = false;
  payLoading = false;
  isVisibleModal = false;
  public users: any = [];
  public usersToDisplay: any = [];
  userRole = null;
  showSelectUser = false;
  creditToAdd = 0;
  selectedUser = 0;
  successCredit = false;
  failCredit = false;
  // public users: any = [];
  isVisible = false;
  userSelected: Users;
  userSelectedName = "";
  public filesData: any = [];
  searchValueEmail = "";
  searchValueName = "";
  searchValueBalanceProcessed = "";
  visible = false;
  searchCredite = "";
  searchStatus = "";
  searchMaxDesktops = "";
  searchCreationDate = "";
  creditsUpdating = false;

  // Unlimited processing variables
  showUnlimitedForm = false;
  selectedUnlimitedUser = 0;
  unlimitedEndDate: Date | null = null;
  savingUnlimited = false;

  pageIndex = 1;
  totalPages = 1;
  pageSize = 10;

  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute, private router: Router, private http: HttpClient, public apiBackendService: ApiBackendService, private msg: NzMessageService) {
    //redirect to home if not logged
    if (!this.authenticationService.currentUserValue) {
      this.router.navigate(["/login"]);
    } else if (this.authenticationService.currentUserInfo.role != "admin") {
      this.router.navigate(["/"]);
    }
    this.userRole = this.authenticationService.currentUserInfo.role;
    this.apiUrl = this.authenticationService.apiUrl;
    this.searchSubject.pipe(debounceTime(500)).subscribe(() => {
      this.getUsers();
    });
  }

  handleCancel(): void {
    this.isVisible = false;

    this.isVisibleModal = false;
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    this.getUsers();

    // this.getCredit();
  }

  getUsers() {
    this.loading = true;
    const filterQuery = new Object();
    filterQuery["searchName"] = this.searchValueName;
    filterQuery["searchEmail"] = this.searchValueEmail;
    filterQuery["searchBalanceProcessed"] = this.searchValueBalanceProcessed;
    filterQuery["searchCredite"] = this.searchCredite;
    filterQuery["searchStatus"] = this.searchStatus;
    filterQuery["searchMaxDesktops"] = this.searchMaxDesktops;
    filterQuery["searchCreationDate"] = this.searchCreationDate;

    this.apiBackendService
      .getUsersPaginated(this.pageSize, this.pageIndex, filterQuery)
      .pipe()
      .subscribe((res) => {
        this.totalPages = res.body["total_pages"] * this.pageSize;
        this.users = res.body["results"];
        this.usersToDisplay = res.body["results"];
        this.loading = false;
      });
  }

  toggleShowSelectUser(entryId) {
    this.showSelectUser = !this.showSelectUser;
    this.selectedUser = entryId;
  }
  saveChangedUser(entryId) {
    this.showSelectUser = !this.showSelectUser;
    this.selectedUser = 0;

    if (this.creditToAdd < 0) {
      this.apiBackendService
        .removeCreditToUser(entryId, this.creditToAdd * -1)
        .pipe()
        .subscribe((res) => {
          if (res.status == 200) {
            this.successCredit = true;
            const userIndex = this.users.findIndex((user) => user.id.toString() === entryId.toString());
            let user = this.users[userIndex];
            const newCredit = Number(user.credit) + Number(this.creditToAdd);
            user.credit = newCredit;
            this.users[userIndex] = user;
          } else {
            this.failCredit = true;
          }
          this.creditToAdd = 0;
        });
    } else {
      this.apiBackendService
        .addCreditToUser(entryId, this.creditToAdd)
        .pipe()
        .subscribe((res) => {
          if (res.status == 200) {
            this.successCredit = true;
            const userIndex = this.users.findIndex((user) => user.id.toString() === entryId.toString());
            let user = this.users[userIndex];
            const newCredit = Number(user.credit) + Number(this.creditToAdd);
            user.credit = newCredit;
            this.users[userIndex] = user;
          } else {
            this.failCredit = true;
          }
          this.creditToAdd = 0;
        });
    }
  }

  showModal(user) {
    this.isVisible = true;
    this.userSelected = user;
    this.userSelectedName = user.firstName + " " + user.lastName;

    this.loadingModal = true;
    this.apiBackendService
      .getTransactionsByUser(user.id)
      .pipe()
      .subscribe((res) => {
        this.filesData = res.body;
        this.loadingModal = false;
      });
  }
  onChange(event) {
    this.searchStatus = event != "status" ? event : "";
    this.pageIndex = 1;
    this.getUsers();
  }

  pageIndexChanged(e) {
    console.log("page index changed", e);
    this.pageIndex = e;
    this.getUsers();
  }
  pageSizeChanged(e) {
    console.log("page size changed", e);
    this.pageSize = e;
    this.getUsers();
  }

  onQueryParamsChange(e) {
    console.log(e);
  }

  filterBy() {
    this.pageIndex = 1;
    this.searchSubject.next();
  }

  updateUsersCredit(): void {
    this.creditsUpdating = true;
    this.apiBackendService.updateUsersCredit().subscribe(
      (res) => {
        this.creditsUpdating = false;
      },
      (error) => {
        this.creditsUpdating = false;
      }
    );
  }

  // Unlimited processing functions
  toggleUnlimitedForm(userId: number): void {
    if (this.showUnlimitedForm && this.selectedUnlimitedUser === userId) {
      // Close form
      this.showUnlimitedForm = false;
      this.selectedUnlimitedUser = 0;
      this.unlimitedEndDate = null;
    } else {
      // Open form for this user
      this.showUnlimitedForm = true;
      this.selectedUnlimitedUser = userId;
      this.unlimitedEndDate = null;
    }
  }

  saveUnlimitedProcessing(userId: number): void {
    if (!this.unlimitedEndDate) {
      this.msg.warning('Selectati o data de sfarsit');
      return;
    }

    this.savingUnlimited = true;

    // Format date as YYYY-MM-DD
    const endDateStr = this.formatDate(this.unlimitedEndDate);

    this.http.post(
      `${this.apiUrl}/grant_unlimited/${userId}`,
      { end_date: endDateStr },
      { observe: 'response' }
    ).subscribe(
      (res: any) => {
        this.savingUnlimited = false;
        this.showUnlimitedForm = false;
        this.selectedUnlimitedUser = 0;
        this.unlimitedEndDate = null;
        this.msg.success(res.body?.message || 'Procesare nelimitata acordata cu succes');
        // Refresh users list
        this.getUsers();
      },
      (error) => {
        this.savingUnlimited = false;
        this.msg.error(error.error?.message || 'Eroare la acordarea procesarii nelimitate');
      }
    );
  }

  cancelUnlimitedForm(): void {
    this.showUnlimitedForm = false;
    this.selectedUnlimitedUser = 0;
    this.unlimitedEndDate = null;
  }

  pendingMaxDesktops: { [userId: number]: number } = {};
  originalMaxDesktops: { [userId: number]: number } = {};

  onMaxDesktopsChange(user: any, value: number): void {
    if (this.originalMaxDesktops[user.id] === undefined) {
      this.originalMaxDesktops[user.id] = user.maxDesktops;
    }
    user.maxDesktops = value;
    if (value !== this.originalMaxDesktops[user.id]) {
      this.pendingMaxDesktops[user.id] = value;
    } else {
      delete this.pendingMaxDesktops[user.id];
      delete this.originalMaxDesktops[user.id];
    }
  }

  confirmMaxDesktops(user: any): void {
    const value = this.pendingMaxDesktops[user.id];
    if (!value || value < 1 || value > 3) return;
    this.apiBackendService.updateMaxDesktops(user.id, value).subscribe(
      () => {
        this.msg.success(`Max PC actualizat la ${value}`);
        delete this.pendingMaxDesktops[user.id];
        delete this.originalMaxDesktops[user.id];
      },
      () => {
        this.msg.error('Eroare la actualizarea Max PC');
      }
    );
  }

  cancelMaxDesktops(user: any): void {
    user.maxDesktops = this.originalMaxDesktops[user.id];
    delete this.pendingMaxDesktops[user.id];
    delete this.originalMaxDesktops[user.id];
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
